// Module
var code = `<div class="filters">
  <div class="labelled-field">
    <label>Select Branch</label>
    <select
      ng-model="\$ctrl.selectedBranchId"
      ng-options="branch.id as branch.name for branch in \$ctrl.branches">
      <option value="">All branch</option>
    </select>
  </div>
  <div class="labelled-field">
    <label>Search by username or name</label>
    <input type="text"
           ng-model="\$ctrl.searchKeyword">
  </div>
  <div class="labelled-field">
    <label>Status</label>
    <select
      ng-model="\$ctrl.selectedStatus"
      ng-options="o.value as o.label for o in [{ label: 'All', value: null }, { label: 'Active', value: true }, { label: 'Blocked', value: false }]">
    </select>
  </div>
  <div class="info__column">
    <!-- Enabled whatever the fields hold: a branch or a status on its own is a search, and an
         emptied keyword only stops filtering on a name once Search has been pressed again. -->
    <button class="btn btn-primary" type="button" ng-click="\$ctrl.search()">
      Search
    </button>
    <button class="btn btn-default" type="button" ng-click="\$ctrl.clearSearch()" ng-disabled="!\$ctrl.searchKeyword">
      Clear
    </button>
    <button class="btn btn-primary" type="button" command-access="CreateUser" ng-click="\$ctrl.addNew()">Add new</button>
  </div>
</div>

<table class="users-list-table table" ng-table="\$ctrl.tableConfig">
  <thead>
  <tr>
    <th>No</th>
    <th>Branch name</th>
    <th>Name</th>
    <th>Status</th>
    <th>Username</th>
    <th>Block category</th>
    <th>Role</th>
    <th>Actions</th>
    <th></th>
  </tr>
  </thead>
  <tbody class="tbody">
  <tr ng-repeat="item in \$data">
    <td class="users-list__number-column">
      {{\$index + 1 + (\$ctrl.tableConfig.page() - 1) * \$ctrl.tableConfig.count()}}.
    </td>
    <td>
      {{\$ctrl.branchNames[item.branchId]}}
    </td>
    <td>{{item.fullName}}</td>
    <td ng-class="{'blocked' : !item.enabled, 'active': item.enabled}">
      {{item.enabled ? 'active' : 'blocked'}}
    </td>
    <td>{{item.username}}</td>
    <td>
      {{item.blockCategory || '-'}}
    </td>
    <td>{{item.allRoles}}</td>
    <td class="users-list__open-link-column">
      <button class="btn btn-warning open-link"
              ng-if="\$ctrl.canOpenUserDetails(item)"
              ng-click="\$ctrl.editUser(item)">Edit</button>
    </td>
    <td class="users-list__open-link-column">
      <button type="button" ng-if="\$ctrl.canDeleteUsers" class="btn btn-danger" ng-click="\$ctrl.deleteUser(item.id)">
        Delete
      </button>
    </td>
  </tr>
  </tbody>
</table>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/users/list/users-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;